var exports = {
  "az": "Box__Qq2Cfr",
  "c0": "NavList__S5oZ6D",
  "En": "TocLevel1__utp0AK",
  "jv": "TocLevel2__4yrl0N",
  "q9": "TocLevel3__pGJ3Y0",
  "xF": "TocLevel4__-wVGJ-",
  "qm": "TocLevel5__02DrSr",
  "x6": "TocLevel6__F2qBYV",
};

module.exports = exports;
